import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=445adb72&scoped=true&"
import script from "./TestimonialCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialCard.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=445adb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445adb72",
  null
  
)

export default component.exports